import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import languageLogo from '../../../resources/language.svg'

import './SwitchLanguage.css'

export const SwitchLanguage = () => {
  const dispatch = useDispatch()
  const languages = useSelector(state => state.locale?.languages)
  const currLocale = useSelector(state => state.locale?.locale)

  const onChoose = locale => {
    dispatch(
      Actions.createAction(Actions.CHANGE_LOCALE_REQUESTED, {
        locale: locale
      })
    )
  }

  return (
    <div className='switch-language-container'>
      {languages && (
        <img src={languageLogo} alt='language' className='language-icon' />
      )}
      {languages &&
        Object.values(languages).map((item, index) => (
          <div key={index} className='language-row'>
            <div
              key={index}
              className={
                item.locale === currLocale
                  ? 'language-button selected'
                  : 'language-button'
              }
              type='secondary'
              onClick={() => onChoose(item.locale)}
            >
              {item.locale_display}
            </div>
            {index !== Object.values(languages).length - 1 ? (
              <div className='language-divider'></div>
            ) : null}
          </div>
        ))}
    </div>
  )
}

export default SwitchLanguage
